var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 64,
    height: 56,
    rx: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 25,
    x2: 72,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 8,
    x2: 24,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 8,
    x2: 56,
    y2: 18
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 42,
    r: 2.5,
    fill: "#fff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 42,
    r: 2.5,
    fill: "#fff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 56 Q40 46 52 56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 52 L72 52 L58 68 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMenuIcon);
export default __webpack_public_path__ + "static/media/noMenuIcon.91c376aecb0fc10544e6de415f320a59.svg";
export { ForwardRef as ReactComponent };